import { put, takeEvery } from 'redux-saga/effects'
import { showLoading as show, hideLoading as hide } from 'react-redux-loading-bar'
import { types as loadingTypes } from '../ducks/loading'

function* showLoading() {
    yield put(show());
}

function* hideLoading() {
    yield put(hide());
}

const loadingSaga = [
    takeEvery(loadingTypes.LOADING_SHOW, showLoading),
    takeEvery(loadingTypes.LOADING_HIDE, hideLoading)
]

export default loadingSaga;
